import { HttpInterceptorFn } from '@angular/common/http';
import { inject } from '@angular/core';
import { catchError } from 'rxjs';
import { AUTH_SERVICE } from './auth-base.service';

export const errorHandlerInterceptor: HttpInterceptorFn = (req, next) => {
  const auth = inject(AUTH_SERVICE);
  return next(req).pipe(
    catchError(error => {
      if (error.error?.statusCode === 401) {
        auth.logout();
      }
      let errorMessage = 'An unexpected error occurred.';
      if (typeof error.error?.message === 'string') {
        errorMessage = error.error.message;
      } else if (error.error?.message?.message) {
        errorMessage = error.error?.message?.message;
      } else if (error.status) {
        errorMessage = `Error ${error.status}: ${error.statusText}`;
      }

      throw new Error(errorMessage);
    })
  );
};
